export default {
  /* Fail Log getters * */
  getFailLogList: state => state.failLogList,
  /* Fail Log 목록 그리드 페이징 처리 필요값 * */
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getPageUnit: state => state.pageUnit,
  getRecords: state => state.records,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/log/logGetters.js